import { createContext, useContext, useState, type ReactNode } from "react";

interface WhiteLabelSettings {
  companyName: string;
  removeBranding: boolean;
  accentColor: string;
}

interface WhiteLabelContextType {
  whiteLabelSettings: WhiteLabelSettings;
  setWhiteLabelSettings: (settings: WhiteLabelSettings) => void;
}

const WhiteLabelContext = createContext<WhiteLabelContextType | undefined>(undefined);

export const WhiteLabelProvider = ({ children }: { children: ReactNode }) => {
  const [whiteLabelSettings, setWhiteLabelSettings] = useState<WhiteLabelSettings>({
    companyName: "",
    removeBranding: false,
    accentColor: "#1e3a5f",
  });

  return (
    <WhiteLabelContext.Provider value={{ whiteLabelSettings, setWhiteLabelSettings }}>
      {children}
    </WhiteLabelContext.Provider>
  );
};

export const useWhiteLabel = () => {
  const ctx = useContext(WhiteLabelContext);
  if (!ctx) throw new Error("useWhiteLabel must be used within WhiteLabelProvider");
  return ctx;
};
